import React from "react";
import { Hero } from "../../components/component";
import AppShowcase from "../../components/apps/AppShowcase";
import Meta from "../../components/Meta";

const Home = ({ content, apps = [], siteSettings }) => {
  return (
    <main>
      <Meta title={content?.metadataTitle} desc={siteSettings?.defaultMetaDescription} />
      <Hero content={content} apps={apps} />
      <AppShowcase apps={apps} />
    </main>
  );
}

export default Home;
